import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HygieneCheckPageComponent } from '../../pages/hygiene-check-page/hygiene-check-page.component';
import { ConfirmDialogComponent } from '../../dialog/confirm-dialog/confirm-dialog.component';
import { TranslateService } from "@ngx-translate/core";
import { DownloadModalService } from '../../../services/download-modal.service';
import { CheckInterface } from '../../../models/check-interface';
import { DownloadModalStatus } from '../../../models/global-interface';
import { CheckStorageService } from '../../../services/check-storage.service';
import { DateToGermanPipe } from '../../../pipes/dateToGerman';
import { TOAST_STATE, ToastService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'lib-audit-card',
  templateUrl: './audit-card.component.html',
  styleUrls: ['./audit-card.component.scss']
})
export class AuditCardComponent implements OnInit, AfterViewInit {

  @Input() check!: CheckInterface;
  @Input() position!: number;
  @ViewChild('editedBox') editedBox!: ElementRef;

  @Output() updateCheckListEvent = new EventEmitter();

  public openCollapse = false;
  isInlineEditingMessage: boolean = false;

  constructor(
    private config: AppConfig,
    public platform: Platform,
    public router: Router,
    public modalCtrl: ModalController,
    public downloadModalService: DownloadModalService,
    public dialog: MatDialog,
    public translateService: TranslateService,
    public checkStorageService: CheckStorageService,
    public layoutService: PHBHPLayoutPackageService
  ) {
    // PLATFORM
  }

  ngOnInit(): void { }

  goToHygieneCheck(checkId: string) {
    localStorage.setItem('departmentName', this.check.departmentName);
    localStorage.setItem('wardName', this.check.wardName);
    localStorage.setItem('wardId', this.check.wardId.toString());
    this.config.checkId = checkId;
    this.layoutService.showLoader = true;
    this.checkStorageService.putCheckEditedBy(checkId, this.config.userData.userId).subscribe(() => {
      this.router.navigate(["/hygiene-check-menu/edit", checkId]);
    });
  }

  ngAfterViewInit(): void {
    this.checkWindowSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkWindowSize();
  }

  private checkWindowSize(): void {
    this.isInlineEditingMessage = window.innerWidth >= 1150;
  }

  async openAppModal(checkId: string, mode?: 'view' | 'edit') {
    const modal = await this.modalCtrl.create({
      component: HygieneCheckPageComponent,
      componentProps: {
        id: checkId,
        mode
      }
    })

    await modal.present();
  }

  getUserName() {
    const userData = localStorage.getItem('userData');
    const userDataJSON = userData ? JSON.parse(userData) : {};
    return userDataJSON['name'];
  }

  deleteCheck(id: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.minWidth = "343px";
    dialogConfig.panelClass = "confirm-dialog-container";
    dialogConfig.data = {
      title: this.layoutService.translateText('CHECK.DELETE_CHECK_QUESTION_TITLE'),
      message: this.layoutService.translateText('CHECK.DELETE_CHECK_QUESTION_MESSAGE'),
      id,
      textCancel: this.layoutService.translateText('BUTTON.CANCEL'),
      textConfirm: this.layoutService.translateText('LAYOUT_MODULE.DELETE'),
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.layoutService.showLoader = true;
        this.checkStorageService.deleteCheck(id).subscribe({
          next: () => {
            this.updateCheckListEvent.emit();
            this.layoutService.showSuccess(this.layoutService.translateText('CHECK.DELETE_CHECK_QUESTION_SUCCESS'), this.layoutService.translateText('CHECK.MODAL_SUCCESS'));
            this.layoutService.showLoader = false;
          },
          error: (err: any) => {
            console.log('Error al eliminar el check', err);
          }
        });
      }
    })
  }

  downloadCheck(check: CheckInterface) {
    const dateTo = DateToGermanPipe.prototype.transformToDownloadModal(check.creationDate);
    const status: DownloadModalStatus = {
      type: 'check',
      id: check.id,
      institutionName: check.institutionName,
      wardName: check.wardName,
      departmentName: this.translateText(check.departmentName),
      creationHour: dateTo[0],
      creationDate: dateTo[1],
      username: check.username
    };

    this.downloadModalService.setDownloadModal(status);
  }

  translateText(text: string) {
    let result: string = text;
    if (result && result.length === 0) return "";
    if (text) {
      this.translateService.get(text).subscribe((res: string) => {
        result = res;
      });
    }
    return result;
  }

  isBeingEdited(check: CheckInterface) {
    return !check.isCompleted && check.editedBy > 0 && check.editedBy != this.config.userData.userId;
  }

  goToViewHygieneCheck(checkId: string) {
    localStorage.setItem('departmentName', this.check.departmentName);
    localStorage.setItem('wardName', this.check.wardName);
    localStorage.setItem('wardId', this.check.wardId.toString());
    this.config.checkId = checkId;
    this.router.navigate(["/hygiene-check-menu/view", checkId]);

  }
  getSolvedQuestions(check){
    return check.solvedQuestions == 0 ? check.newSolvedQuestions : check.solvedQuestions;
  }
}
